module.exports = __webpack_public_path__ + "img/expand-wide.cb2f1d42.svg";